module.exports = ".date {\r\n    color: #9E9E9E;\r\n    padding-bottom: 25px;\r\n    padding-top: 15px;\r\n}\r\n\r\n.dot {\r\n    height: 7px;\r\n    width: 7px;\r\n    background-color: #bbb;\r\n    border-radius: 50%;\r\n    display: inline-block;\r\n    margin-right: 8px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/nullable-date.css
// module id = 280
// module chunks = 1